import React, { useEffect, useState } from "react";
import clsx from "clsx";
import _ from "lodash";
import CustomTransactionHistoryAll from "../../../components/CustomTransactionHistoryAll";
import * as axiosInstance from "../../../services/axiosInstance";
import Helper from "../../../utils/Helper";
import { useQuery } from "@tanstack/react-query";
import { useDispatch, useSelector } from "react-redux";
import * as StorageManager from "../../../utils/StorageManager";
import constants from "../../../constants";
import * as authSelectors from "../../../selectors/auth";
import ViewDocumentModal from "./modal/ViewDocumentModal";
import * as generalSelectors from "../../../selectors/general";
import { getGeneralOptionsPaymentStatus } from "../../../selectors/general";
import PAGE from "../../../utils/Destination";

function TransactionHistory({ generalData }) {
  const [page, setPage] = useState(1);
  const [viewData, setViewData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null);
  const [status, setStatus] = useState(null);
  const dispatch = useDispatch();
  const [token, setToken] = useState(null);
  const isLogout = useSelector((state) => authSelectors.getAuthIsLogout(state));
  const paymentStatus = generalSelectors.getGeneralOptionsPaymentStatus(generalData);
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    setTokenFunction();
  }, [isLogout]);

  async function setTokenFunction() {
    setToken(await StorageManager.retrieveToken(constants.AUTH_TOKEN));
  }

  const depositeHistoryData = useQuery({
    queryKey: ["depositeHistoryList", { page, status, dateFrom, dateTo }],
    queryFn: async () => {
      try {
        const dateQuery =
          !_.isEmpty(dateFrom) && !_.isEmpty(dateTo)
            ? `&created_at_from=${dateFrom}&created_at_to=${dateTo}`
            : "";
        const statusQuery = !_.isEmpty(status) ? `&status=${status}` : "";

        return await axiosInstance.get(`/clientarea/deposit?page=${page}${statusQuery}${dateQuery}`);
      } catch (e) {
        Helper.handleHttpError(e, dispatch);
      }
    },
    retryDelay: 15000,
    enabled:
      !_.isEmpty(token) &&
      ((!_.isEmpty(dateFrom) && !_.isEmpty(dateTo)) || (_.isEmpty(dateFrom) && _.isEmpty(dateTo))),
  });
  const onClickViewPayment = async (clientCode, id) => {
    try {
      const response = await axiosInstance.get(`/clientarea/deposit/${id}`, true, false);
      if (!_.isEmpty(response.data)) {
        setViewData(response.data);
        setShowModal(true);
      } else {
      }
    } catch (e) {
    } finally {
      // setLoading(false);
    }
  };
  const onClickDeleteFunction = async (url) => {
    const confirmed = window.confirm("Are you sure you want to cancel this item?");
    if (!confirmed) {
      return;
    }
    setLoading(true);
    try {
      const result = await axiosInstance.del(`${url}`);
      await depositeHistoryData.refetch();
      return result;
    } catch (e) {
    } finally {
      setLoading(false);
      setShowModal(false);
    }
  };

  const onClickViewDocument = async (url) => {
    try {
      const res = await fetch(url.replace("http", "https").replace("httpss", "https"), {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`, // Here you can set any headers you want
        },
      });
      const blob = await res.blob();

      const urlObject = URL.createObjectURL(blob);
      window.open(urlObject, "_links");
    } catch (e) {
      console.log("ee" + e);
    } finally {
    }
  };
  const handleCloseModal = () => {
    setShowModal(false);
    setViewData(null);
  };

  return (
    <div className="container-fluid">
      <div className={"primary-border-table-border"} style={{ backgroundColor: "white" }}>
        <div className={clsx("custom-card-label-container text-center")}>
          <h2>Transaction History</h2>
        </div>
        <div className="transaction-history-container">
          <CustomTransactionHistoryAll
            data={depositeHistoryData}
            page={page}
            setPage={setPage}
            onClickViewPayment={onClickViewPayment}
            viewData={viewData}
            statusOptions={paymentStatus}
            statusFilter={status}
            onChangeStatus={(e) => setStatus(e.target.value)}
            dateFrom={dateFrom}
            dateTo={dateTo}
            onChangeDateFrom={(e) => setDateFrom(e.target.value)}
            onChangeDateTo={(e) => setDateTo(e.target.value)}
            showModal={showModal}
            handleCloseModal={handleCloseModal}
            onClickDeleteFunction={onClickDeleteFunction}
            loading={loading}
          ></CustomTransactionHistoryAll>
          {/*<Tabs defaultActiveKey="1" id="uncontrolled-tab-example" className="mb-3 px-2">*/}
          {/*  <Tab eventKey="1" title="All" className="tab-button">*/}
          {/*    */}
          {/*  </Tab>*/}
          {/*  /!*<Tab eventKey="2" title="Manual Transfer" className="tab-button">*!/*/}
          {/*  /!*  <CustomTransactionHistoryManualTransfer></CustomTransactionHistoryManualTransfer>*!/*/}
          {/*  /!*</Tab>*!/*/}
          {/*  /!*<Tab eventKey="3" title="Online FPX Transfer" className="tab-button">*!/*/}
          {/*  /!*  <CustomTransactionHistoryFPXTransfer></CustomTransactionHistoryFPXTransfer>*!/*/}
          {/*  /!*</Tab>*!/*/}
          {/*</Tabs>*/}
        </div>
      </div>
      <ViewDocumentModal
        show={showModal}
        handleClose={handleCloseModal}
        data={viewData}
        onClickViewDocument={onClickViewDocument}
        onClickDeleteFunction={onClickDeleteFunction}
        loading={loading}
      ></ViewDocumentModal>
    </div>
  );
}
export default TransactionHistory;
